import { InsightFilterType } from '@buildwise/libs/insights/apis/PythonInsightsAPI';

export const projectsQueryKeys = {
  insights: ({
    companyId,
    projectId,
    groupBy,
    filters,
    includeBWInsights,
  }: {
    companyId: string;
    projectId: string;
    groupBy: string;
    filters?: InsightFilterType[];
    includeBWInsights: boolean;
  }) => ['project-insights', companyId, projectId, groupBy, filters, includeBWInsights],
  insightsSearch: ({
    companyId,
    projectId,
    groupBy,
    novaSearchKeyWord,
    filters,
    includeBWInsights,
  }: {
    companyId: string;
    projectId: string;
    groupBy: string;
    novaSearchKeyWord: string;
    filters?: InsightFilterType[];
    includeBWInsights: boolean;
  }) => [
    'project-insights-search',
    companyId,
    projectId,
    groupBy,
    novaSearchKeyWord,
    filters,
    includeBWInsights,
  ],
  insightsSummary: ({
    companyId,
    directory,
    filters,
    groupBy,
    includeBWInsights,
    projectId,
  }: {
    companyId: string;
    directory: string[];
    filters?: InsightFilterType[];
    groupBy: string;
    includeBWInsights: boolean;
    projectId: string;
  }) => [
    'project-insights-summary',
    companyId,
    projectId,
    groupBy,
    directory,
    filters,
    includeBWInsights,
  ],
  insightsSummarySearch: ({
    companyId,
    projectId,
    groupBy,
    directory,
    novaSearchKeyWord,
    filters,
    includeBWInsights,
  }: {
    companyId: string;
    directory: string[];
    filters?: InsightFilterType[];
    groupBy: string;
    includeBWInsights: boolean;
    novaSearchKeyWord: string;
    projectId: string;
  }) => [
    'project-insights-summary-search',
    companyId,
    projectId,
    groupBy,
    directory,
    novaSearchKeyWord,
    filters,
    includeBWInsights,
  ],
  getActivityLog: ({ companyId, objectType }: { companyId: string; objectType: string }) => [
    'activity-log',
    companyId,
    objectType,
  ],
};
